import { Howl } from 'howler';
import { makeCreatePlayer } from './makeCreatePlayer';

const createPlayer = makeCreatePlayer({ Howl });

export { createPlayer };

// Commit trace: 2025-07-21T04:33:03 - fix: fix edge case in index.js
